import { createZustandStore } from "@bounce/state-management"
import type { BasicObject } from "@bounce/util"

import type { Variant } from "../types"

export enum OverrideMode {
  /** Return the real variant if no override is set */
  Default = "default",
  /** Only return overrides */
  OverridesOnly = "overrides-only",
}

type VariantOverridesStore = {
  mode: OverrideMode
  overrides: BasicObject<Variant>
  addOverride: (key: string, override: Variant) => void
  removeOverride: (key: string) => void
  clear: () => void
}

export const useVariantOverrides = createZustandStore<VariantOverridesStore>({
  name: "useVariantOverrides",
  initializer: setState => ({
    mode: OverrideMode.Default,
    overrides: {},
    addOverride: (key, override) => {
      setState(({ overrides }) => ({
        overrides: {
          ...overrides,
          [key]: override,
        },
      }))
    },
    removeOverride: key => {
      setState(({ overrides: { [key]: _valueToDelete, ...rest } }) => ({
        overrides: rest,
      }))
    },
    clear: () => {
      setState({ overrides: {} })
    },
  }),
  persistStore: true,
})
